import React, { useEffect, useState } from 'react'

import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'
import { Button, BUTTON_THEME, IconButton, Input } from '@st-operations/uikit/src/v2/index.js'

import './styles.scss'

const ModalCloneTaxonomy = ({ selectedTaxonomies, isModalCloneOpen, clone, closeModal }) => {
  const actionLabel = 'Clone With Audiences'
  const [taxonomies, setTaxonomies] = useState({})

  useEffect(() => {
    setTaxonomies(
      selectedTaxonomies.reduce(
        (acc, taxonomy) => ({
          ...acc,
          [taxonomy._id]: { ...taxonomy, originalName: taxonomy.name, slug: '' },
        }),
        {}
      )
    )
  }, [selectedTaxonomies])

  useEffect(() => {
    if (isModalCloneOpen && selectedTaxonomies.length === 0) {
      closeModal()
      toast.error('No taxonomy selected.')
    }
  }, [isModalCloneOpen && selectedTaxonomies])

  const handleChange = (id) => (value, name) => {
    setTaxonomies((prevState) => ({
      ...prevState,
      [id]: {
        ...prevState[id],
        [name]: value,
      },
    }))
  }

  return (
    <Dialog open={isModalCloneOpen} className="modal-clone-taxonomy">
      <header className="modal-clone-taxonomy__header">
        <h2>{actionLabel}</h2>
        <IconButton
          onClick={closeModal}
          aria-label="Close modal"
          iconProps={{
            icon: 'delete',
            type: 'fill',
            width: 16,
            height: 16,
            color: '#3d3d3d',
          }}
        />
      </header>
      <section className="modal-clone-taxonomy__list">
        <For each="taxonomy" of={Object.values(taxonomies)}>
          <div key={taxonomy._id} className="modal-clone-taxonomy__item">
            <h4 className="modal-clone-taxonomy__name">{taxonomy.originalName}</h4>
            <Input
              name="name"
              label="New Taxonomy Name"
              value={taxonomy.name}
              onChange={handleChange(taxonomy._id)}
            />
            <Input
              name="slug"
              label="New Taxonomy Slug"
              description="Optional. If left blank, it will be generated from the name."
              value={taxonomy.slug}
              onChange={handleChange(taxonomy._id)}
            />
          </div>
        </For>
      </section>
      <footer className="modal-clone-taxonomy__footer">
        <div className="modal-clone-taxonomy__actions">
          <Button onClick={closeModal} theme={BUTTON_THEME.SECONDARY}>
            Cancel
          </Button>
          <Button
            onClick={() => {
              clone(taxonomies)
              closeModal()
            }}
          >
            {actionLabel}
          </Button>
        </div>
      </footer>
    </Dialog>
  )
}

export default ModalCloneTaxonomy
